import Grid from '@mui/material/Grid';
//import ExplorerSectionHeader from './ExplorerSectionHeader';
import { GetGeneTable } from './GetGeneTable';


export default function ExplorerSection() {
  
return (
<>

<Grid container >   

        {/* Gene Explorer */}
        <Grid item  xs={12}> <GetGeneTable /> </Grid>

</Grid>

</>
)}